module.exports = __webpack_public_path__ + "img/album07_06.0275d7d1.jpg";